import getMillisecondsDiff from './getMillisecondsDiff'

export default getMillisecondsDiff
